import { Segmented } from 'antd';
import { useContext } from 'react';

import { ColorModeContext } from '@/contexts/ColorModeContext';

const ThemeSegmented = () => {
  const { mode, toggleMode } = useContext(ColorModeContext);

  return (
    <Segmented
      shape="round"
      block
      options={[
        {
          label: '🔆',
          value: 'light',
        },
        {
          label: '🌛',
          value: 'dark',
        },
      ]}
      onChange={() => {
        toggleMode();
      }}
      value={mode}
    />
  );
};

export default ThemeSegmented;
